export const RESTRICTION_ID = 'RESTRICTION_ID';
